module.exports = __webpack_public_path__ + "img/onholdtick.a4bd9db3.svg";